import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside.directive';
import { SwitchThemeLogoDirective } from './switch-theme-logo.directive';
import { DragDirective } from './drag.directive';



@NgModule({
  declarations: [
    ClickOutsideDirective,
    SwitchThemeLogoDirective,
    DragDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ClickOutsideDirective,
    SwitchThemeLogoDirective,
    DragDirective,
  ]
})
export class DirectivesModule { }
